import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './VideoGallery.scss';

const decodeHtmlEntities = (text) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

const VideoGallery = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const YOUTUBE_CHANNEL_ID = 'UCsoTkuHUvOPC2ZceJA6NGGw';
  const YOUTUBE_API_KEY = 'AIzaSyD6A7wnu51WN0wWmNXXUk_jgwTfXwksSLU'; // Bu kısmı kendi API anahtarınızla değiştirin

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(
          `https://www.googleapis.com/youtube/v3/search?key=${YOUTUBE_API_KEY}&channelId=${YOUTUBE_CHANNEL_ID}&part=snippet,id&order=date&maxResults=12&type=video`
        );

        setVideos(response.data.items);
        setLoading(false);
      } catch (err) {
        setError('Videolar yüklenirken bir hata oluştu.');
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  if (loading) {
    return (
      <div className="video-gallery-loading">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Yükleniyor...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return <div className="video-gallery-error">{error}</div>;
  }

  return (
    <div className="video-gallery">
      <div className="container">
        <div className="services-grid-title">
          <h2>Video Galeri</h2>
        </div>
        <div className="row">
          {videos.slice(0, 6).map((video) => (
            <div key={video.id.videoId} className="col-md-6 col-lg-4 mb-4">
              <a
                href={`https://www.youtube.com/watch?v=${video.id.videoId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="video-card"
              >
                <div className="video-thumbnail">
                  <img
                    src={video.snippet.thumbnails.high.url}
                    alt={decodeHtmlEntities(video.snippet.title)}
                    className="img-fluid"
                  />
                  <div className="play-button">
                    <svg viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z" fill="currentColor" />
                    </svg>
                  </div>
                </div>
                <div className="video-info">
                  <h3>{decodeHtmlEntities(video.snippet.title)}</h3>
                  <p>{new Date(video.snippet.publishedAt).toLocaleDateString('tr-TR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}</p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoGallery;
